import React, { useState, useEffect, useCallback } from 'react';
import Modal from '../../components/modal';
import { useInternals } from '../../context/internalContext';
import { useAuxiliaries } from '../../context/auxiliariesContext';
import QuickAddModal from '../../components/modal/quickAddModal';
import useSubmitLock from '../../utils/useSubmitLock';
import './discipline.css';

const DisciplinaryFault = ({ internalId, onClose, onUpdate }) => {
  const { createDisciplinaryFault } = useInternals();
  const { listTypeDisciplinaryFaults, createTypeDisciplinaryFault } = useAuxiliaries();

  const [formData, setFormData] = useState({
    notes: '',
    date_infraction: '',
    disciplinary_fault: '',
  });

  const [faultTypes, setFaultTypes] = useState([]); // Lista de tipos de faltas disciplinares
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();

  const fetchFaultTypes = useCallback(async () => {
    try {
      const response = await listTypeDisciplinaryFaults();
      const faultList = response?.results || [];
      setFaultTypes(faultList);
      return faultList;
    } catch (error) {
      console.error('Erro ao buscar tipos de faltas disciplinares:', error);
      return [];
    }
  }, [listTypeDisciplinaryFaults]);

  useEffect(() => {
    fetchFaultTypes();
  }, [fetchFaultTypes]);

  const handleAddFaultType = async (name) => {
    const trimmedName = String(name || '').trim();
    if (!trimmedName) return;

    const created = await createTypeDisciplinaryFault({ name: trimmedName });
    const refreshedFaults = await fetchFaultTypes();

    if (created?.id) {
      setFormData((prev) => ({ ...prev, disciplinary_fault: String(created.id) }));
      return;
    }

    const createdByName = refreshedFaults.find(
      (fault) => String(fault?.name || '').toLowerCase() === trimmedName.toLowerCase()
    );
    if (createdByName?.id) {
      setFormData((prev) => ({ ...prev, disciplinary_fault: String(createdByName.id) }));
    }
  };

  // Submissão do formulário
  const handleSubmit = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      try {
        await createDisciplinaryFault({
          ...formData,
          internal: internalId,
        });

        setFormData({ notes: '', date_infraction: '', disciplinary_fault: '' });

        if (onUpdate) {
          onUpdate(); // Notifica o componente pai para atualizar a linha do tempo
        }

        onClose(); // Fecha o modal após salvar
      } catch (error) {
        console.error('Erro ao registrar falta disciplinar:', error);
      }
    });
  };

  return (
    <Modal title="Registrar Falta Disciplinar" isOpen={true} closeModal={onClose}>
      <form onSubmit={handleSubmit} className="discipline-form">
        <label>Descrição:</label>
        <textarea
          name="notes"
          value={formData.notes}
          onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
          required
        />

        <label>Data da infração:</label>
        <input
          type="datetime-local"
          name="date_infraction"
          value={formData.date_infraction}
          onChange={(e) => setFormData({ ...formData, date_infraction: e.target.value })}
          required
        />

        <label>Falta Disciplinar:</label>
        <div className="container-quick-modal">
          <div className="form-group-lager">
            <select
              name="disciplinary_fault"
              value={formData.disciplinary_fault}
              onChange={(e) => setFormData({ ...formData, disciplinary_fault: e.target.value })}
              required
            >
              <option value="">Selecione uma falta</option>
              {faultTypes.map((fault) => (
                <option key={fault.id} value={fault.id}>
                  {fault.name}
                </option>
              ))}
            </select>
          </div>

          <QuickAddModal
            label="Falta disciplinar"
            fields={[
              { name: 'name', placeholder: 'Nome da falta', type: 'text' },
            ]}
            onAdd={async (data) => handleAddFaultType(data.name)}
          />
        </div>

        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Salvando...' : 'Salvar'}
        </button>
      </form>
    </Modal>
  );
};

export default DisciplinaryFault;
